<template>
  <div class="app-container">
    <img class="img" :src="brotherPositionList[presentPositionId - 1].img" />
    <template v-if="brotherPositionList[presentPositionId - 1].device.length > 0">
      <vue-drag-resize
        v-for="(item, i) in brotherPositionList[presentPositionId - 1].device"
        :key="i"
        :isDraggable="false"
        :isResizable="false"
        :parentLimitation="true"
        :z="2"
        :w="28"
        :h="28"
        :x="item.position[1]"
        :y="item.position[0]"
        ref="blockSon"
        v-on:clicked="showDialog(item.id)"
      >
        <img
          width="100%"
          :src="
            item.onlineStatus === 0
              ? require('@/assets/images/info_off.png')
              : require('@/assets/images/info_on.png')
          "
        />
      </vue-drag-resize>
    </template>
    <div class="right-nav">
      <el-row>
        <el-col>
          <i class="el-icon-arrow-up toolRight" @click="reduceIndex"></i>
        </el-col>
      </el-row>
      <el-row style="height: 335px">
        <el-col>
          <div class="toolUl">
            <template v-for="(position, index) in brotherPositionList">
              <template
                v-if="
                  index >= (positionPage - 1) * 6 && index < positionPage * 6
                "
              >
                <a class="liA" :key="index">
                  <span
                    :class="
                      position.positionId === presentPositionId
                        ? 'liItemActive'
                        : 'liItem'
                    "
                    @click="changeMap(position.positionId)"
                  >
                    {{ position.positionName }}
                  </span>
                </a>
              </template>
            </template>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <i class="el-icon-arrow-down toolRight" @click="addIndex"></i>
        </el-col>
      </el-row>
    </div>
    <el-dialog title="设置设备状态" :visible.sync="dialogVisible" width="400px">
      <label>运行状态：</label>
      <el-button @click="informationDeviceSwitch(0)">关闭</el-button>
      <el-button type="primary" @click="informationDeviceSwitch(1)"
        >打开</el-button
      >
    </el-dialog>
  </div>
</template>

<script>
import { informationDeviceList, informationDeviceStatus, informationDeviceSwitch } from '@/api/business/base/tenant/fireFightingSystem'

export default {
  data() {
    return {
      // 右侧导航
      brotherPositionList: [
        // {
        //   positionId: 0,
        //   positionName: '地下室',
        //   img: require('@/assets/bg/bgb1.png'),
        //   device: []
        // },
        {
          positionId: 1,
          positionName: 'F01',
          img: require('@/assets/bg/bg1.png'),
          // 104 109 101 112
          device: [
            { id: 17, position: [412, 802], onlineStatus: 0 },
            { id: 20, position: [460, 970], onlineStatus: 0 },
            { id: 21, position: [368, 1270], onlineStatus: 0 },
            { id: 24, position: [480, 980], onlineStatus: 0 },
          ]
        },
        {
          positionId: 2,
          positionName: 'F02',
          img: require('@/assets/bg/bg2.png'),
          // 103 102
          device: [
            { id: 15, position: [412, 827], onlineStatus: 0 },
            { id: 23, position: [352, 1297], onlineStatus: 0 }
          ]
        },
        {
          positionId: 3,
          positionName: 'F03',
          img: require('@/assets/bg/bg3.png'),
          // 113  114
          device: [
            { id: 16, position: [415, 874], onlineStatus: 0 },
            { id: 22, position: [323, 1340], onlineStatus: 0 }
          ]
        },
        {
          positionId: 4,
          positionName: 'F04',
          img: require('@/assets/bg/bg4.png'),
          // 115 116
          device: [
            { id: 25, position: [446, 974], onlineStatus: 0 },
            { id: 19, position: [350, 1277], onlineStatus: 0 }
          ]
        },
        {
          positionId: 5,
          positionName: 'F05',
          img: require('@/assets/bg/bg5.png'),
          // 106 105
          device: [
            { id: 26, position: [472, 972], onlineStatus: 0 },
            { id: 27, position: [380, 1234], onlineStatus: 0 }
          ]
        },
        // {
        //   positionId: 6,
        //   positionName: 'F06',
        //   img: require('@/assets/bg/bg6.png'),
        //   device: []
        // },
        // {
        //   positionId: 7,
        //   positionName: 'F07-16',
        //   img: require('@/assets/bg/bg7-16.png'),
        //   device: []
        // },
        {
          positionId: 6,
          positionName: 'F17',
          img: require('@/assets/bg/bg17.png'),
          // 110
          device: [
            { id: 14, position: [310, 721], onlineStatus: 0 }
          ]
        },
        // {
        //   positionId: 9,
        //   positionName: '屋顶',
        //   img: require('@/assets/bg/bgTop.png'),
        //   device: []
        // },
      ],
      //位置当前页
      positionPage: 1,
      // 当前选中
      presentPositionId: 1,
      // 弹框
      dialogVisible: false,
      // 设备ID
      deviceId: null,
      // 状态
      state: 0
    }
  },
  created() {
    // this.informationDeviceList()
    this.informationDeviceStatus()
  },
  methods: {
    //减少位置索引
    reduceIndex() {
      if (this.positionPage > 1) {
        this.positionPage = this.positionPage - 1;
      }
    },
    //增加位置索引
    addIndex() {
      let length = this.brotherPositionList.length;
      let pageSize = parseInt(length / 6);
      let maxPage = length % 6 == 0 ? pageSize : pageSize + 1;
      if (this.positionPage < maxPage) {
        this.positionPage = this.positionPage + 1;
      }
    },
    // 设备列表
    informationDeviceList() {
      informationDeviceList().then(res => {
        console.log(res)
      })
    },
    // 切换地图
    changeMap(positionId) {
      this.presentPositionId = positionId
      this.informationDeviceStatus()
    },
    // 获取设备状态
    informationDeviceStatus() {
      const index = this.presentPositionId - 1
      this.deviceStatus = []
      this.brotherPositionList[index].device.map(v => {
        informationDeviceStatus({ deviceId: v.id }).then(res => {
          v.onlineStatus = res.data.onlineStatus
        })
      })
    },
    // 设置设备状态
    informationDeviceSwitch(state) {
      informationDeviceSwitch({ deviceId: this.deviceId, state: state }).then(res => {
        if (res.code === 200) {
          this.$message({ message: res.msg, type: 'success' })
          this.dialogVisible = false
        } else {
          this.$message({ message: res.msg, type: 'error' })
        }

      })
    },
    // 打开弹框
    showDialog(id) {
      this.deviceId = id
      this.dialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  position: relative;
  text-align: center;
  width: 1700px;
  .img {
    width: 1400px;
  }
  .monitorType {
    position: absolute;
  }
  .right-nav {
    position: absolute;
    width: 150px;
    height: 458px;
    z-index: 999;
    right: 20px;
    top: calc(50% - 200px);
  }
  .toolUl {
    width: 100%;
    height: 306px;
    padding: 0px;
    margin-top: 8px;
    margin-bottom: 0px;
    transition: width 0.5s;
  }
  .liItem {
    display: block;
    position: absolute;
    right: 0px;
    width: 40px;
    height: 40px;
    border-radius: 40px;
    overflow: hidden;
    box-shadow: inset 0px 1px 0px rgba(255, 255, 255, 0.3),
      0 3px 2px rgba(0, 0, 0, 0.45);
    border-color: #0880d7;
    background: #2798eb;

    color: #fff;
    text-align: center;
    line-height: 40px;
    margin-bottom: 15px;
    transition: width 1s;
    -moz-transition: width 1s; /* Firefox 4 */
    -webkit-transition: width 1s; /* Safari and Chrome */
    -o-transition: width 1s; /* Opera */
    /*border-color: #0880d7;*/
    /*background: #2798eb;*/
  }

  .liItemActive {
    display: block;
    position: absolute;
    right: 0px;
    width: 40px;
    height: 40px;
    border-radius: 40px;
    overflow: hidden;
    box-shadow: inset 0px 1px 0px rgba(255, 255, 255, 0.3),
      0 3px 2px rgba(0, 0, 0, 0.45);
    background-color: #a5de37;
    border-color: #a5de37;

    color: #fff;
    text-align: center;
    line-height: 40px;
    margin-bottom: 15px;
    transition: width 1s;
    -moz-transition: width 1s; /* Firefox 4 */
    -webkit-transition: width 1s; /* Safari and Chrome */
    -o-transition: width 1s; /* Opera */
  }

  .liItem:hover,
  .liItemActive:hover {
    width: 100%;
  }

  .liA {
    display: block;
    height: 40px;
    margin-bottom: 16px;
  }

  .toolUl:hover {
    width: 100%;
  }

  .toolRight {
    float: right;
    cursor: pointer;
    margin-right: 12px;
  }

  @keyframes magentaPulse {
    from {
      background-color: rgba(255, 0, 0, 0.6);
      border-radius: 10px;

      -webkit-box-shadow: 0 0 20px 3px red;
      box-shadow: 0 0 20px 3px red;
    }
    25% {
      background-color: rgba(255, 255, 0, 0.6);
      border-radius: 10px;
      -webkit-box-shadow: 0 0 20px 3px yellow;
      box-shadow: 0 0 20px 3px yellow;
    }
    50% {
      background-color: rgba(255, 0, 0, 0.6);
      border-radius: 10px;

      -webkit-box-shadow: 0 0 20px 3px red;
      box-shadow: 0 0 20px 3px red;
    }
    80% {
      background-color: rgba(255, 255, 0, 0.6);
      border-radius: 10px;
      -webkit-box-shadow: 0 0 20px 3px yellow;
      box-shadow: 0 0 20px 3px yellow;
    }
    to {
      background-color: rgba(255, 0, 0, 0.6);
      border-radius: 10px;

      -webkit-box-shadow: 0 0 20px 3px red;
      box-shadow: 0 0 20px 3px red;
    }
  }
  @-webkit-keyframes magentaPulse {
    from {
      background-color: rgba(255, 0, 0, 0.6);
      border-radius: 10px;

      -webkit-box-shadow: 0 0 20px 3px red;
      box-shadow: 0 0 20px 3px red;
    }
    25% {
      background-color: rgba(255, 255, 0, 0.6);
      border-radius: 10px;
      -webkit-box-shadow: 0 0 20px 3px yellow;
      box-shadow: 0 0 20px 3px yellow;
    }
    50% {
      background-color: rgba(255, 0, 0, 0.6);
      border-radius: 10px;

      -webkit-box-shadow: 0 0 20px 3px red;
      box-shadow: 0 0 20px 3px red;
    }
    80% {
      background-color: rgba(255, 255, 0, 0.6);
      border-radius: 10px;
      -webkit-box-shadow: 0 0 20px 3px yellow;
      box-shadow: 0 0 20px 3px yellow;
    }
    to {
      background-color: rgba(255, 0, 0, 0.6);
      border-radius: 10px;

      -webkit-box-shadow: 0 0 20px 3px red;
      box-shadow: 0 0 20px 3px red;
    }
  }
  /*  重复动画  */

  a.button {
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
  }
  /*  动画名称、动画完成时间  */

  .magentaPulse.button {
    -webkit-animation-name: magentaPulse;
    animation-name: magentaPulse;
    -webkit-animation-duration: 0.8s;
    animation-duration: 0.8s;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
  }
  /deep/ .el-dialog__header {
    text-align: left;
  }
  /deep/ .el-dialog__body {
    padding-bottom: 40px;
  }
}
</style>